module.exports = __webpack_public_path__ + "static/media/whiteLogo.fa952556.png";